/**
 * HorizonScroll
 * Version: 1.0.2
 * URL: https://github.com/trgraglia/jquery.horizonScroll.js/
 * Description: This is a jQuery plugin which allows for websites to scroll left and right.
 * Requires: jQuery 1.10.2
 * Optional: jQuery TouchSwipe (http://labs.rampinteractive.co.uk/touchSwipe/)
 * Author: Anthony Graglia
 * Copyright: Copyright 2013 Anthony Graglia
 * License: MIT License
 */

// Semicolon to prevent breakage with concatenation.
;
(function ($) {
    'use strict';
  var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };    

  if(!isMobile.any()) {

     $('.carousel-control-next').tooltip();
  }

  $('.carousel-control-next').hide();
      
  $('.carousel-control-next').on({ 'touchend' : function(){ 
    $('.carousel-control-next').tooltip('hide');
  }});

  $('<div id="overlay-50"><div class="loader_"></div></div>').insertAfter('#pageCarousel');



  Pace.on('done', function() {

    // alert($('#pageCarousel').length);
    $('.carousel-control-next').show();
    setTimeout(function(){
      $('#overlay-50').remove();
    },1000)
    if($('#pageCarousel').length){
          $(document).getActivityProgress();
          // $('#pageCarousel').css('visibility','visible');
        }
  });

    $.fn.horizon = function (options, i) {
      

        if (options === 'scrollLeft') {
            scrollLeft();
        } else if (options === 'scrollRight') {
            scrollRight();
        } else if (options === 'scrollTo') { // TODO: Should verify i here
            scrollTo(i, $.fn.horizon.defaults.scrollDuration);
        } else {
            $.extend($.fn.horizon.defaults, options);

            $.fn.horizon.defaults.sections = this;
            $.fn.horizon.defaults.limit = this.length;
            $.fn.horizon.defaults.i = 0;

             setTimeout(function(){
              sizeSections();  
            },2000);

            $(document).on('click', '.horizon-next', function () {
              $('.p-block').removeClass('inactive');
                scrollRight();
            }).on('click', '.horizon-prev', function () {
              $('.p-block').removeClass('inactive');
                scrollLeft();
            });


            $(window).on('resize', function () {
                // sizeSections();
            }).on('keydown', function (e) {

                if (scrolls[e.which]) {
                    scrolls[e.which]();
                    e.preventDefault();
                }
            });

            return this;
        }
    };

    $.fn.horizon.defaults = {
        scrollTimeout: null,
        scrollEndDelay: 250,
        scrollDuration: 400,
        i: 0,
        limit: 0,
        docWidth: 0,
        sections: null,
        swipe: true,
        fnCallback: function (i) {
          var i = i;
          setTimeout(function(){
      
        var ll = $('.p-block');
        ll.each(function(k,v){
          console.log(k +"________"+i)
          // if(k!=i)
          //   $(this).addClass('inactive');
        })
          },5000)
      


        }
    };

// HTML animate does not work in webkit. BODY does not work in opera.
// For animate, we must do both.
// http://stackoverflow.com/questions/8790752/callback-of-animate-gets-called-twice-jquery
    var scrollTo = function (index, speed) {

        console.log('Scroll to: ' + index);
        
        if (index > ($.fn.horizon.defaults.limit - 1) || index < 0) {
            return;
        }

        var $section = $($.fn.horizon.defaults.sections[index]);
        

        $('html,body').animate({scrollLeft: $section.offset().left}, speed, 'swing', $.fn.horizon.defaults.fnCallback(index));


        if (index === 0) {

            $('.horizon-prev').hide();
            $('.horizon-next').show();
        } else if (index === $.fn.horizon.defaults.limit - 1) {
            $('.horizon-prev').show();
            $('.horizon-next').hide();
        } else {
            $('.horizon-next').show();
            $('.horizon-prev').show();
        }
    };

    var scrollLeft = function () {
        console.log('Scroll left');

        if ($.fn.horizon.defaults.i > 0) {
            scrollTo(--$.fn.horizon.defaults.i, $.fn.horizon.defaults.scrollDuration);
        }
    };

    var scrollRight = function () {
        console.log('Scroll right');
        
        if ($.fn.horizon.defaults.i < $.fn.horizon.defaults.limit - 1) {
            scrollTo(++$.fn.horizon.defaults.i, $.fn.horizon.defaults.scrollDuration);
        }
    };

// Executes on 'scrollbegin'.
    var scrollBeginHandler = function (delta) {
        // Scroll up, Scroll down.
        if (delta > 1) {
            scrollLeft();
        } else if (delta < -1) {
            scrollRight();
        }
    };

// Executes on 'scrollend'.
    var scrollEndHandler = function () {
        $.fn.horizon.defaults.scrollTimeout = null;
    };

    var scrollAction = function (delta) {
        if ($.fn.horizon.defaults.scrollTimeout === null) {
            scrollBeginHandler(delta);
        } else {
            clearTimeout($.fn.horizon.defaults.scrollTimeout);
        }

        $.fn.horizon.defaults.scrollTimeout = setTimeout(scrollEndHandler, $.fn.horizon.defaults.scrollEndDelay);
    };

    var sizeSections = function () {
        

        var iInnerWidth = $(window).innerWidth();

        $.fn.horizon.defaults.docWidth = iInnerWidth;
        $.fn.horizon.defaults.sections.each(function () {
            $(this).width(iInnerWidth);
        console.log($(this).height());
        });
        $('html').width($.fn.horizon.defaults.limit * iInnerWidth);

        scrollTo($.fn.horizon.defaults.i, 0);
    };

    var scrolls = {
        'right': scrollLeft,
        'down': scrollLeft,
        'left': scrollRight,
        'up': scrollRight,
        37: scrollLeft,
        38: scrollLeft,
        39: scrollRight,
        40: scrollRight
    };

})
(jQuery);

// SCROLLING NOTES
// http://stackoverflow.com/questions/4989632/differentiate-between-scroll-up-down-in-jquery
// http://stackoverflow.com/questions/4289473/javascript-do-an-action-after-user-is-done-scrolling


$(document).ready(function(){
    setTimeout(function(){
        $('#overlay').remove();
    },2000);

  $('.read-more-rs button.b-ws').on("click",function(){
   $('.read-more-rs button.b-ws').hide();
    //;
    var self = $(this);
    $('html, body').animate({ scrollTop: 0}, 500, 'easeOutCubic',function(){
       

    });
  });

  $('.read-more-cs button.t-ws').on("click",function(){

    var self = $(this);
    self.hide()
    var tcon = self.parent().parent().find('.t-container');
    tcon.hide();

    var c_count = tcon.html().length;
    $(this).parents('body').append('<div id="overlay-50"><div class="loader_"></div></div>');
    if(c_count>0){
      tcon.fadeIn();
        tcon.find('div[data-component-status]').attr('data-component-status',1);
      setTimeout(function(){
        self.parent().find('.b-ws').show().css('display','inline-block');
        $('#overlay-50').remove();
        $('html, body').animate({ scrollTop: tcon.offset().top-74}, 500, 'easeOutCubic');
      },2000);
    }else{
      $.ajax({
         type:'get',
         url:'/page-topics/'+$(this).attr('data-page-id'),
         success:function(data){
            tcon.html(data);
            tcon.fadeIn();
            tcon.find('div[data-component-status]').attr('data-component-status',1);
            setTimeout(function() {
                plyr.setup('.t-container video');
                  // $("video").on("play", function() {
                  //   var id = $(this).attr('id');

                  //   $("video").not(this).each(function(index, video) {
                  //       video.pause();
                  //     });
                  // });

                  
                self.parent().find('.b-ws').show().css('display','inline-block');
                //call all topic related js functions again
                $(".hotgraphic-widget").hotgrapghics();//hotgrapghics
                $( ".simple_slider" ).simple_slider();//slider
                $("a:contains('More info')").moreinfo();//two level list
                $(".t-container .cs-sm-audio,.t-container .cs-cm-video").transcript();//audio video trnascript
                $('#overlay-50').remove();
                $('html, body').animate({ scrollTop: tcon.offset().top-74}, 500, 'easeOutCubic');
                $('.cs-cm-graphic-position,.cs-cm-graphic-slider').parents('section').css("height","auto");
            },2000);
         }
      });
    }
  });

  setTimeout(function() {
    if($('.carousel-control-next').is(':visible')) {
        // $('.carousel-control-next').tooltip('show');
    }
  }, 5000);

  // $('html,body').animate({scrollLeft: 0});
  // var tt = $('.p-block');
  // tt.each(function(){
  //   console.log($(this).height()+" height p-block");
  //   var sec = $(this).find('section');
  //   var hei = 0;
  //   sec.each(function(){

  //     hei = hei + $(this).outerHeight(false) ;
  //   })
  //   console.log(hei+" height p-block");

  // })

  // $('.p-block').horizon();
  // $('html,body').animate({scrollLeft:0});
	plyr.setup();

  $("video").on("play", function() {
    var id = $(this).attr('id');

    $("video").not(this).each(function(index, video) {
        video.pause();
      });
  });


  
   // $('.cm-main > div').attr('data-rellax-speed',5);
    $.fn.extend({
        componentCustomHeight: function() {

            /* Old method of centering case study content using padding.*/
     		/*
            ++var panel_height = $(window).height()-$('header').height();  
      		$('.panel-height').height($(window).height()-$('header').height()-$('footer').height())    	
         
            $('.cm-main').each(function(){
                var pd = (panel_height/2 - $(this).height()/2);
                console.log($(this).height());
                if($(this).hasClass('n-pd'))
                  pd = pd <=100? "24%" : (2*pd)+"px"
                else
                pd = pd <=100? "12%" : pd+"px"

                $(this).css("padding-top",pd).css("padding-bottom",pd);     
            });*/



            var panel_height = $(window).height()-$('header').outerHeight() - $('footer').outerHeight() - $('.carousel-indicators-p').outerHeight();  
      
            /* Adjust height of content panel to each case studies carousel-items */
            $('.carousel-item > section').each(function(){
                $(this).css('height', panel_height);

                /* Force scroll on carousel item if content height exceeds available space */
                // if( $(this).find('.cm-main').length ) {
                //     if( panel_height < $( $(this).find('.cm-main div')[0]).outerHeight() ) {
                //         $(this).addClass('section-scroll');
                //     } else {
                //         $(this).removeClass('section-scroll');
                //     }
                // }
            });

            /* Vertically center carousel left, right nav buttons in panel */
            $('#pageCarousel .carousel-control-prev').css('top', (panel_height / 2)+20);
            $('#pageCarousel .carousel-control-next').css('top', (panel_height / 2)+20);


        }
    });

(function( $ ) {
  $.fn.stopScroll = function( options ) {
    options = $.extend({
      delay: 200,
      callback: function() {}
    }, options);
    
    return this.each(function() {
      var $element = $( this ),
        element = this;
      $element.scroll(function() {
        clearTimeout( $.data( element, "scrollCheck" ) );
        $.data( element, "scrollCheck", setTimeout(function() {
          options.callback();
        }, options.delay ) );
      });
    });
  };

})( jQuery );


    $( window ).scroll(function() {
        var height = $(window).scrollTop();
        var panel_height = $(window).height()-$('header').outerHeight() - $('footer').outerHeight() - $('.carousel-indicators-p').outerHeight();  

        if(height ==0){
                  $('.t-container').hide();
                  $('.t-ws').fadeIn('slow').css('display','inline-block');
                }

        if(height  > 200) {
            $('.carousel-c').hide();
        }else{
          

          clearTimeout( $.data( this, "scrollCheck" ) );
          $.data( this, "scrollCheck", setTimeout(function() {

            $carousel = $('#pageCarousel .carousel-item.active');
            var component_status = $carousel.find('div[data-component-status=0]').attr('data-component-status');
            // console.log(component_status);

            var compl = $carousel.find('div[data-max-attempts]');
            
            var attempts =  compl.attr('data-component-attempts');
            var max_attempts = compl.attr('data-max-attempts');

            var mx_status = true;

            
            if(typeof compl !="undefined" && attempts<max_attempts){
                mx_status = false;
            }

            // attempts>=max_attempts


            if(typeof component_status=="undefined" && mx_status &&  $carousel.index()!=0 && !$carousel.is(':last-child')){
                    console.log("calling by ipad");
                          $('.carousel-c').show();
                        }
            else if($carousel.index()!=0)
              $('.carousel-control-prev').show();

           
          }, 200) );



            

            // compl.each(function(k,v){
                
                
            //     console.log("max_attempts"+max_attempts>=attempts);
            //     if(max_attempts>=attempts)
            //         $('.carousel-control-next').hide();


            // })

        }

        if(height  > (panel_height-50)) {
            $('.read-more-rs button.b-ws').fadeIn('slow').css('display','inline-block');
        }else{
            $('.read-more-rs button.b-ws').hide();
        }
    });

    $('.carousel-indicators-p li').on("click", function(){
        setTimeout(function() {
            $(document).componentCustomHeight();
        },50);
        
    });



    //assign carousel li data-slide-to attribute value to according slide index in carousel
    var carousel_li = $('.carousel-indicators-p li');
    $.each(carousel_li,function(i,li){
        var slider_index = $('.carousel-item[data-stage-index="'+i+'"]').index();
        $(li).attr("data-slide-to",slider_index);
    });
    //initially hide prev button
//    $('.carousel-control-prev').fadeOut('slow');



    //onload set status as 1 for component block and page
    var current_page = $(".carousel-item.active");
    $(current_page).attr("data-page-status", 1);
    var firstSliderBlock = $(current_page).find("[data-block-status]");
    $(firstSliderBlock).attr("data-block-status", 1);
    // $(this).checkStatus(current_page)


    //get all the navigation properties of myCarousel
    var carouselNavElements = $(".carousel-indicators-p li");
    //set the disabled attribute to true for the carousel's nav elements
    carouselNavElements.prop('disabled', true);
    carouselNavElements.addClass("li-disabled");



    $('.carousel-control-next').on("click",function(){
        $(this).hide();
        $('.carousel-control-next').tooltip('hide');
        var cs_ds_status =  $('.cs-dashboard').attr('data-component-status');
        // alert(cs_ds_status);
        if(cs_ds_status==0)    
          $('.cs-dashboard-charts').hide();
    });


    //on carousal slid run all functions
    $('#pageCarousel').on('slide.bs.carousel', function () {
      console.log(1);
        var el = $('.carousel-item.active');
        var a_ls = el.find('audio') ;
        a_ls.each(function(k,v){
          var a = $(this)
          a[0].currentTime = 0
          a[0].pause();
        }) ;       

        $('.carousel-c').stop(true,true);
        $('.carousel-control-next').hide();
    });
    $('#pageCarousel').on('slid.bs.carousel', function () {
        $('.carousel-control-next').hide();
       
        var c_length = $(this).find('.carousel-item').length;
        var el = $('.carousel-indicators-p li');
        $('.t-container').hide();
        $('.b-ws').hide();
        $('.t-ws').fadeIn('slow').css('display','inline-block');
        $current_index = $('.carousel-indicators-p .active').index();
        el.removeClass('active');
        
        current_page = $('.carousel-item.active');
        var $stage_id = current_page.attr('data-stage-index');

        el.eq($stage_id).addClass('active');
        el.eq($stage_id).removeClass('li-disabled');
        el.eq($stage_id).prop('disabled', false);

        if(current_page.index() == 0)
          $('.carousel-control-prev').hide();
        else
          $('.carousel-control-prev').show();

        setTimeout(function(){
            $(document).componentCustomHeight();
            if($('.tooltip').is(':visible')) {
                $('.carousel-control-next').tooltip('hide');
            }
        },50);
        var components = $(this).getComponents(current_page.find('section').first());
        $.each(components, function(i,ct){
            var ls_check = $(ct.component).attr("data-component-status"); 
            
            if(ls_check==0){

                switch(ct.type){
                  case "text":
                  case "media_video":
                  case "media_audio":
                  case "infographic":
                    $(ct.component).attr("data-component-status",1);
                  break;

                  }
                  
                    $(this).submitlog(ct.component,current_page);
            }else{
              if(current_page.index() != c_length-1){
                
                              $('.carousel-control-next').show();}
            }

          


        });



        if(current_page.index() == c_length-1)
          $('.carousel-control-next').hide();

    });

    $('.carousel-control-next').watch({
        properties: "display",
        callback: watchNext
    });

    function watchNext(data, i) {
        var propChanged = data.props[i];
        var valChanged = data.vals[i];
        if(valChanged == 'flex') {
            setTimeout(function() {
                if($('.carousel-control-next').is(':visible')) {
                    // $('.carousel-control-next').tooltip('show');
                }
            }, 5000);
        }
        console.log(" Changed Property: " + propChanged + "  -  New Value: " + valChanged);
    };
   

    $(document).componentCustomHeight();

    $( window ).resize(function() {
        $(document).componentCustomHeight();
    });  
});